import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import BuildForm from '../../components/BuildForm/BuildForm';
import { sendBuild, validateBitrise } from '../../utils/services/bitrise-service';
import { checkFastfileExists, getBranches, getClients, getTags } from '../../utils/services/gitlab-service';
import PageDefault from '../PageDefault/PageDefault';
import { getBitriseToken } from '../../utils/services/service';

import './Build.scss';
import { StorageEnum } from '../../utils/enumerators/Storage.enum';

function BuildIos() {
	const [bitriseState, setBitriseState] = useState(true);
	const [tags, setTags] = useState([]);
	const [branches, setBranches] = useState([]);
	const [selectedTarget, setSelectedTarget] = useState(null);
	const [clients, setClients] = useState([]);
	const [version, setVersion] = useState(0);
	const [sequential, setSequential] = useState('');
	const [fastfileExists, setFastfileExists] = useState(false);

	function onChangeTarget(tag) {
		setSelectedTarget(tag);
	}

	async function onSubmit(selectedClients, selectedWorkflow, selectedSequential, releaseNotes, target, automaticRelease) {
		await sendBuild(selectedClients, selectedWorkflow, selectedTarget, selectedSequential, releaseNotes, automaticRelease);

		let title = 'Build Enviada!';
		let text = 'A build foi enviada para o Bitrise! Acompanhe seu andamento pelo dashbord.';

		if (selectedClients.length > 1) {
			title = 'Build enviadas!';
			text = 'As builds foram enviadas para o Bitrise! Acompanhe os seus andamentos pelo dashbord.';
		}

		if (target && releaseNotes) {
			localStorage.setItem(`${StorageEnum.RELEASE_NOTES}-${target}-ios`, releaseNotes);
		}

		Swal.fire({
			icon: 'success',
			title,
			text,
			buttons: {
				confirm: 'OK',
			},
		}).then(() => {
			window.location.reload(false);
		});
	}

	//Ao iniciar a tela
	useEffect(async () => {
		try {
			await getBitriseToken();

			await validateBitrise();

			const tagList = await getTags();
			setTags(tagList);

			const branchList = await getBranches();
			setBranches(branchList);
		} catch (e) {
			setBitriseState(false);
		}
	}, []);

	//Quando mudar o target
	useEffect(async () => {
		setClients([]);
		if (selectedTarget) {
			const { clients, sequential, version } = await getClients(selectedTarget);

			setTimeout(() => {
				setClients(clients);
				setSequential(sequential);
				setVersion(Number(version.replace(/[^0-9]/g, '')));
			}, 500); //TODO: Remove timeout
		} else {
			setClients([]);
		}
		setFastfileExists(await checkFastfileExists(selectedTarget, false));
	}, [selectedTarget]);
	return (
		<PageDefault>
			<div className="app-main">
				<div className="app-header">Geração de Build iOS</div>

				{((tags.length === 0 && branches.length == 0) || (selectedTarget && clients.length === 0)) && <span className="message">Carregando...</span>}

				{!bitriseState && <span className="message">Há um erro com a conexão com o Bitrise. Verifique as chaves e API.</span>}

				{bitriseState && (
					<>
						{tags.length > 0 && (
							<BuildForm
								tags={tags}
								branches={branches}
								clients={clients}
								onChangeTarget={onChangeTarget}
								onSubmit={onSubmit}
								sequential={sequential}
								version={version}
								fastfileExists={fastfileExists}
							/>
						)}
					</>
				)}
			</div>
		</PageDefault>
	);
}

export default BuildIos;
